import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  IconButton,
  Tooltip,
  Button,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartIcon from "@mui/icons-material/TableChart";
import { exportBillingToPDF, exportBillingToExcel } from "../billingExportUtils";

export const ProviderCard = ({
  provider,
  data,
  totals,
  color,
  bgColor,
  month = "Current",
  onRowClick,
  columnName,
}) => {
  const formatNumber = (value) =>
  new Intl.NumberFormat("en-IN").format(value);

  return (
    <Card
      sx={{
        border: "3px solid #1e3a5f",
        borderRadius: "14px",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.06)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent sx={{ p: 2.5, flexGrow: 1 }}>

        {/* ================= Header ================= */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" gap={1.2}>
            <Typography
              sx={{
                fontSize: "1.35rem",
                fontWeight: 700,
                color,
              }}
            >
              {provider}
            </Typography>

            {/* Active Badge */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.6,
                backgroundColor: "#e6f4ea",
                px: 1.3,
                py: 0.35,
                borderRadius: "20px",
              }}
            >
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "#2e7d32",
                }}
              />
              <Typography sx={{ fontSize: "0.72rem", fontWeight: 600, color: "#2e7d32" }}>
                Active
              </Typography>
            </Box>
          </Box>

          {/* Export Icons */}
          <Box>
            <Tooltip title="Download PDF">
              <IconButton
                size="small"
                onClick={() => exportBillingToPDF(provider, data, totals, month)}
                sx={{ color: "#d32f2f" }}
              >
                <PictureAsPdfIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Download Excel">
              <IconButton
                size="small"
                onClick={() => exportBillingToExcel(provider, data, totals, month)}
                sx={{ color: "#2e7d32" }}
              >
                <TableChartIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {/* ================= Table Header ================= */}
        <Grid
          container
          sx={{
            backgroundColor: "#f8f9fb",
            borderRadius: "8px",
            px: 1.5,
            py: 1,
            borderBottom: "1px solid #dee2e6",
          }}
        >
          <Grid item xs={5}>
            <Typography sx={{ fontSize: "0.78rem", fontWeight: 700 }}>
              Plan Name
            </Typography>
          </Grid>
          <Grid item xs={2} textAlign="center">
            <Typography sx={{ fontSize: "0.78rem", fontWeight: 700 }}>
              Total SIMs
            </Typography>
          </Grid>
          {!columnName ? (
            <Grid item xs={2.5} textAlign="center">
            <Typography sx={{ fontSize: "0.78rem", fontWeight: 700 }}>
              Total Bill
            </Typography>
          </Grid>
          ): (
           <Grid item xs={2.5} textAlign="center">
            <Typography sx={{ fontSize: "0.78rem", fontWeight: 700 }}>
              Plan Code
            </Typography>
          </Grid> 
          )}
          
          <Grid item xs={2.5} textAlign="center">
            <Typography sx={{ fontSize: "0.78rem", fontWeight: 700 }}>
              Action
            </Typography>
          </Grid>
        </Grid>

        {/* ================= Table Rows ================= */}
        <Box sx={{ mt: 1 }}>
          {data.map((item, index) => (
            <Grid
              container
              key={index}
              alignItems="center"
              sx={{
                px: 1.5,
                py: 1.2,
                borderBottom: "1px solid #edf0f3",
                "&:hover": { backgroundColor: "#f6f8fa" },
              }}
            >
              <Grid item xs={5}>
                <Typography sx={{ fontSize: "0.82rem", fontWeight: 500 }}>
                  {item.planName}
                </Typography>
              </Grid>

              <Grid item xs={2} textAlign="center">
                <Typography sx={{ fontSize: "0.82rem" }}>
                  {formatNumber(item.totalSims)}
                </Typography>
              </Grid>

                {!columnName ? (

              <Grid item xs={2.5} textAlign="center">
                <Typography sx={{ fontSize: "0.82rem", fontWeight: 600 }}>
                  ₹{formatNumber(item.monthlyBill)}
                </Typography>
              </Grid>
                ): (
                  <Grid item xs={2.5} textAlign="center">
                <Typography sx={{ fontSize: "0.82rem", fontWeight: 600 }}>
                  {item.planCode}
                </Typography>
              </Grid>
                )}

              <Grid item xs={2.5} textAlign="center">
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => onRowClick({ ...item, provider })}
                  sx={{
                    backgroundColor: color,
                    fontSize: "0.72rem",
                    textTransform: "none",
                    px: 1.6,
                    py: 0.5,
                    borderRadius: "6px",
                    boxShadow: "none",
                    "&:hover": { backgroundColor: color, opacity: 0.9 },
                  }}
                >
                  View Details
                </Button>
              </Grid>
            </Grid>
          ))}
        </Box>
      </CardContent>

      {/* ================= Footer ================= */}
      <Box
        sx={{
          backgroundColor: bgColor || "#eaf4fb",
          px: 2.5,
          py: 1.5,
          borderBottomLeftRadius: "12px",
          borderBottomRightRadius: "12px",
        }}
      >
        <Grid container>
  <Grid item xs={6}>
    <Typography sx={{ fontSize: "0.9rem", fontWeight: 700 }}>
      Total SIMs: {formatNumber(totals.sims)}
    </Typography>
  </Grid>

  <Grid item xs={6} textAlign="right">
    {!columnName && (
      <Typography sx={{ fontSize: "0.9rem", fontWeight: 700 }}>
      Total Monthly Bill: ₹{formatNumber(totals.bill)}
    </Typography>
    )}
  </Grid>
</Grid>
      </Box>
    </Card>
  );
};
